export default __webpack_public_path__ + "dcca80b6b9cf4303506305c0a14d5e42.svg";